var _path, _path2, _path3, _path4;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgDocumentOutlined(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M19.5 2.5H4.5L4.5 21.5H19.5V2.5ZM19.5 1H4.5C3.67157 1 3 1.67157 3 2.5V21.5C3 22.3284 3.67157 23 4.5 23H19.5C20.3284 23 21 22.3284 21 21.5V2.5C21 1.67157 20.3284 1 19.5 1Z",
    fill: "#222222"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M6.00001 8.75C6.00001 8.33579 6.3358 8 6.75001 8H17.25C17.6642 8 18 8.33579 18 8.75C18 9.16422 17.6642 9.5 17.25 9.5H6.75001C6.3358 9.5 6.00001 9.16422 6.00001 8.75Z",
    fill: "#222222"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M6.00001 12.75C6.00001 12.3358 6.3358 12 6.75001 12H17.25C17.6642 12 18 12.3358 18 12.75C18 13.1642 17.6642 13.5 17.25 13.5H6.75001C6.3358 13.5 6.00001 13.1642 6.00001 12.75Z",
    fill: "#222222"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M6.00001 16.75C6.00001 16.3358 6.3358 16 6.75001 16H17.25C17.6642 16 18 16.3358 18 16.75C18 17.1642 17.6642 17.5 17.25 17.5H6.75001C6.3358 17.5 6.00001 17.1642 6.00001 16.75Z",
    fill: "#222222"
  })));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgDocumentOutlined);
export default __webpack_public_path__ + "static/media/document-outlined.94e261a6.svg";
export { ForwardRef as ReactComponent };